module.exports = __webpack_public_path__ + "public/images/expert_img.bfb268f8b404d8a012e1f8daa97c79b0.webp";